
import { List } from '@luxtag/papybase';
import moment from 'moment';

export const MUTATE_SHOW_WELCOME_MESSAGE = 'MUTATE_SHOW_WELCOME_MESSAGE';
export const MUTATE_SHOW_VERIFY_EMAIL = 'MUTATE_SHOW_VERIFY_EMAIL';
export const MUTATE_LAST_RESEND_EMAIL_TIMESTAMP = 'MUTATE_LAST_RESEND_EMAIL_TIMESTAMP';
export const MUTATE_SHOW_UPGRADE_PLAN = 'MUTATE_SHOW_UPGRADE_PLAN';
export const MUTATE_INDUSTRIES = 'MUTATE_INDUSTRIES';
export const MUTATE_GOALS = 'MUTATE_GOALS';
export const MUTATE_SOURCES = 'MUTATE_SOURCES';

interface IInterfaceStore {
    showWelcomeMessage: boolean;
    showVerifyEmail: boolean;
    showUpgradePlan: boolean;
    lastResendEmailTimeStamp: number | undefined;
    industries:List[];
    goals:List[];
    sources:List[];
    templateMaxImage: number;
    multipleImage: boolean;
}

// initial state
const InterfaceState: IInterfaceStore = {
    showWelcomeMessage: false,
    showVerifyEmail: false,
    showUpgradePlan: false,
    lastResendEmailTimeStamp: moment().unix(),
    industries: [],
    goals: [],
    sources: [],
    templateMaxImage: 1,
    multipleImage: false,
};

// getters
const getters = {
    getShowWelcomeMessage: (state: IInterfaceStore) => state.showWelcomeMessage,
    getShowVerifyEmail: (state: IInterfaceStore) => state.showVerifyEmail,
    getShowUpgradePlan: (state: IInterfaceStore) => state.showUpgradePlan,
    getLastResendEmailTimeStamp: (state: IInterfaceStore) => state.lastResendEmailTimeStamp,
    getIndustries: (state: IInterfaceStore) => state.industries,
    getGoals: (state: IInterfaceStore) => state.goals,
    getSources: (state: IInterfaceStore) => state.sources,
    getMaxImage: (state: IInterfaceStore) => state.templateMaxImage,
    isMultipleImage: (state: IInterfaceStore) => state.multipleImage,
};

// mutations
const mutations = {
    [MUTATE_SHOW_WELCOME_MESSAGE](state: IInterfaceStore, payload: boolean) {
        state.showWelcomeMessage = payload;
    },
    [MUTATE_SHOW_VERIFY_EMAIL](state: IInterfaceStore, payload: boolean) {
        state.showVerifyEmail = payload;
    },
    [MUTATE_SHOW_UPGRADE_PLAN](state: IInterfaceStore, payload: boolean) {
        state.showUpgradePlan = payload;
    },
    [MUTATE_LAST_RESEND_EMAIL_TIMESTAMP](state: IInterfaceStore, payload: number) {
        state.lastResendEmailTimeStamp = payload;
    },
    [MUTATE_INDUSTRIES](state: IInterfaceStore, payload: List[]) {
        state.industries = payload;
    },
    [MUTATE_GOALS](state: IInterfaceStore, payload: List[]) {
        state.goals = payload;
    },
    [MUTATE_SOURCES](state: IInterfaceStore, payload: List[]) {
        state.sources = payload;
    },
};

// actions
const actions = {
};

export default {
    state: InterfaceState,
    getters,
    actions,
    mutations,
};
